import { Style } from './StyleFunctions';

export const DarkGreenText = '#008057';

export const userSelectStyle: Style = {
  userSelect: 'text',
  '-webkit-user-select': 'text',
  '-moz-user-select': 'text',
  '-ms-user-select': 'text',
};

// These colors are referenced in the DQW tooltip
export const DataQualityDetailPanelWidth = 300;
export const DataQualityDetailPanelMaxHeight = 500;
export const DataQualityStatusChipBackgroundColor = '#D7ECF9';
export const DataQualityStatusChipSevereBackgroundColor = '#FEF9EF';
export const DataQualityStatusTitleColor = '#0F445E';
export const DataQualityStatusSevereTitleColor = '#333333';
